module.exports = __webpack_public_path__ + "static/media/Patricia y los apagones.7c63ff49.pdf";